import { useMemo } from "react";
import baseballIcon from "../../../public/images/sports/icons/baseball.svg";
import basketballIcon from "../../../public/images/sports/icons/basketball.svg";
import cheerleadingIcon from "../../../public/images/sports/icons/cheerleading.svg";
import footballIcon from "../../../public/images/sports/icons/football.svg";
import hockeyIcon from "../../../public/images/sports/icons/hockey.svg";
import lacrosseIcon from "../../../public/images/sports/icons/lacrosse.svg";
import soccerIcon from "../../../public/images/sports/icons/soccer.svg";
import softballIcon from "../../../public/images/sports/icons/softball.svg";
import trackAndFieldIcon from "../../../public/images/sports/icons/track-and-field.svg";
import volleyballIcon from "../../../public/images/sports/icons/volleyball.svg";
import wrestlingIcon from "../../../public/images/sports/icons/wrestling.svg";
import baseballHeroXs from "../../../public/images/sports/hero/baseball-xs.png";
import baseballHeroSm from "../../../public/images/sports/hero/baseball-sm.png";
import baseballHeroMd from "../../../public/images/sports/hero/baseball-md.png";
import baseballHeroLg from "../../../public/images/sports/hero/baseball-lg.png";
import basketballHeroXs from "../../../public/images/sports/hero/basketball-xs.png";
import basketballHeroSm from "../../../public/images/sports/hero/basketball-sm.png";
import basketballHeroMd from "../../../public/images/sports/hero/basketball-md.png";
import basketballHeroLg from "../../../public/images/sports/hero/basketball-lg.png";
import cheerleadingHeroXs from "../../../public/images/sports/hero/cheerleading-xs.png";
import cheerleadingHeroSm from "../../../public/images/sports/hero/cheerleading-sm.png";
import cheerleadingHeroMd from "../../../public/images/sports/hero/cheerleading-md.png";
import cheerleadingHeroLg from "../../../public/images/sports/hero/cheerleading-lg.png";
import footballHeroXs from "../../../public/images/sports/hero/football-xs.png";
import footballHeroSm from "../../../public/images/sports/hero/football-sm.png";
import footballHeroMd from "../../../public/images/sports/hero/football-md.png";
import footballHeroLg from "../../../public/images/sports/hero/football-lg.png";
import hockeyHeroXs from "../../../public/images/sports/hero/hockey-xs.png";
import hockeyHeroSm from "../../../public/images/sports/hero/hockey-sm.png";
import hockeyHeroMd from "../../../public/images/sports/hero/hockey-md.png";
import hockeyHeroLg from "../../../public/images/sports/hero/hockey-lg.png";
import lacrosseHeroXs from "../../../public/images/sports/hero/lacrosse-xs.png";
import lacrosseHeroSm from "../../../public/images/sports/hero/lacrosse-sm.png";
import lacrosseHeroMd from "../../../public/images/sports/hero/lacrosse-md.png";
import lacrosseHeroLg from "../../../public/images/sports/hero/lacrosse-lg.png";
import soccerHeroXs from "../../../public/images/sports/hero/soccer-xs.png";
import soccerHeroSm from "../../../public/images/sports/hero/soccer-sm.png";
import soccerHeroMd from "../../../public/images/sports/hero/soccer-md.png";
import soccerHeroLg from "../../../public/images/sports/hero/soccer-lg.png";
import softballHeroXs from "../../../public/images/sports/hero/softball-xs.png";
import softballHeroSm from "../../../public/images/sports/hero/softball-sm.png";
import softballHeroMd from "../../../public/images/sports/hero/softball-md.png";
import softballHeroLg from "../../../public/images/sports/hero/softball-lg.png";
import trackAndFieldHeroXs from "../../../public/images/sports/hero/track-and-field-xs.png";
import trackAndFieldHeroSm from "../../../public/images/sports/hero/track-and-field-sm.png";
import trackAndFieldHeroMd from "../../../public/images/sports/hero/track-and-field-md.png";
import trackAndFieldHeroLg from "../../../public/images/sports/hero/track-and-field-lg.png";
import volleyballHeroXs from "../../../public/images/sports/hero/volleyball-xs.png";
import volleyballHeroSm from "../../../public/images/sports/hero/volleyball-sm.png";
import volleyballHeroMd from "../../../public/images/sports/hero/volleyball-md.png";
import volleyballHeroLg from "../../../public/images/sports/hero/volleyball-lg.png";
import wrestlingHeroXs from "../../../public/images/sports/hero/wrestling-xs.png";
import wrestlingHeroSm from "../../../public/images/sports/hero/wrestling-sm.png";
import wrestlingHeroMd from "../../../public/images/sports/hero/wrestling-md.png";
import wrestlingHeroLg from "../../../public/images/sports/hero/wrestling-lg.png";
import otherSportsHeroXs from "../../../public/images/sports/hero/other-sports-xs.png";
import otherSportsHeroSm from "../../../public/images/sports/hero/other-sports-sm.png";
import otherSportsHeroMd from "../../../public/images/sports/hero/other-sports-md.png";
import otherSportsHeroLg from "../../../public/images/sports/hero/other-sports-lg.png";
// import bgOrangeM from "../../../public/images/sports/hero-bgs/bg_orange_m.svg";
// import bgOrangeT from "../../../public/images/sports/hero-bgs/bg_orange_t.svg";
// import bgOrangeD from "../../../public/images/sports/hero-bgs/bg_orange.svg";
import bgBlueM from "../../../public/images/sports/hero-bgs/bg_blue_m.svg";
import bgBlueT from "../../../public/images/sports/hero-bgs/bg_blue_t.svg";
import bgBlueD from "../../../public/images/sports/hero-bgs/bg_blue.svg";
import bgMintM from "../../../public/images/sports/hero-bgs/bg_mint_m.svg";
import bgMintT from "../../../public/images/sports/hero-bgs/bg_mint_t.svg";
import bgMintD from "../../../public/images/sports/hero-bgs/bg_mint.svg";
import bgYellowM from "../../../public/images/sports/hero-bgs/bg_yellow_m.svg";
import bgYellowT from "../../../public/images/sports/hero-bgs/bg_yellow_t.svg";
import bgYellowD from "../../../public/images/sports/hero-bgs/bg_yellow.svg";
import bgGreenM from "../../../public/images/sports/hero-bgs/bg_green_m.svg";
import bgGreenT from "../../../public/images/sports/hero-bgs/bg_green_t.svg";
import bgGreenD from "../../../public/images/sports/hero-bgs/bg_green.svg";
import bgPurpleM from "../../../public/images/sports/hero-bgs/bg_purple_m.svg";
import bgPurpleT from "../../../public/images/sports/hero-bgs/bg_purple_t.svg";
import bgPurpleD from "../../../public/images/sports/hero-bgs/bg_purple.svg";
// import bgPurple2M from "../../../public/images/sports/hero-bgs/bg_purple2_m.svg";
// import bgPurple2T from "../../../public/images/sports/hero-bgs/bg_purple2_t.svg";
// import bgPurple2D from "../../../public/images/sports/hero-bgs/bg_purple2.svg";
import baseballRegistrationImage from "../../../public/images/sports/registration/baseball.png";
import basketballRegistrationImage from "../../../public/images/sports/registration/basketball.png";
import cheerleadingRegistrationImage from "../../../public/images/sports/registration/cheerleading.png";
import footballRegistrationImage from "../../../public/images/sports/registration/football.png";
import hockeyRegistrationImage from "../../../public/images/sports/registration/hockey.png";
import lacrosseRegistrationImage from "../../../public/images/sports/registration/lacrosse.png";
import otherSportsRegistrationImage from "../../../public/images/sports/registration/other-sports.png";
import soccerRegistrationImage from "../../../public/images/sports/registration/soccer.png";
import softballRegistrationImage from "../../../public/images/sports/registration/softball.png";
import trackAndFieldRegistrationImage from "../../../public/images/sports/registration/track-and-field.png";
import volleyballRegistrationImage from "../../../public/images/sports/registration/volleyball.png";
import wrestlingRegistrationImage from "../../../public/images/sports/registration/wrestling.png";
import baseballSchedulingImage from "../../../public/images/sports/scheduling/baseball.png";
import basketballSchedulingImage from "../../../public/images/sports/scheduling/basketball.png";
import cheerleadingSchedulingImage from "../../../public/images/sports/scheduling/cheerleading.png";
import footballSchedulingImage from "../../../public/images/sports/scheduling/football.png";
import hockeySchedulingImage from "../../../public/images/sports/scheduling/hockey.png";
import lacrosseSchedulingImage from "../../../public/images/sports/scheduling/lacrosse.png";
import otherSportsSchedulingImage from "../../../public/images/sports/scheduling/other-sports.png";
import soccerSchedulingImage from "../../../public/images/sports/scheduling/soccer.png";
import softballSchedulingImage from "../../../public/images/sports/scheduling/softball.png";
import trackAndFieldSchedulingImage from "../../../public/images/sports/scheduling/track-and-field.png";
import volleyballSchedulingImage from "../../../public/images/sports/scheduling/volleyball.png";
import wrestlingSchedulingImage from "../../../public/images/sports/scheduling/wrestling.png";

type Color =
  | "orange"
  | "blue"
  | "mint"
  | "yellow"
  | "green"
  | "purple"
  | "purple2";

const useSportsData = (type: string) => {
  const {
    icon,
    heroImageXs,
    heroImageSm,
    heroImageMd,
    heroImageLg,
    colorType,
    registrationImage,
    schedulingImage,
  } = useMemo(() => {
    let icon;
    let heroImageXs;
    let heroImageSm;
    let heroImageMd;
    let heroImageLg;
    let registrationImage;
    let schedulingImage;
    let colorType: Color = "blue";
    switch (type) {
      case "Baseball":
        icon = baseballIcon;
        heroImageXs = baseballHeroXs;
        heroImageSm = baseballHeroSm;
        heroImageMd = baseballHeroMd;
        heroImageLg = baseballHeroLg;
        registrationImage = baseballRegistrationImage;
        schedulingImage = baseballSchedulingImage;
        colorType = "blue";
        break;
      case "Basketball":
        icon = basketballIcon;
        heroImageXs = basketballHeroXs;
        heroImageSm = basketballHeroSm;
        heroImageMd = basketballHeroMd;
        heroImageLg = basketballHeroLg;
        registrationImage = basketballRegistrationImage;
        schedulingImage = basketballSchedulingImage;
        colorType = "purple";
        break;
      case "Cheerleading":
        icon = cheerleadingIcon;
        heroImageXs = cheerleadingHeroXs;
        heroImageSm = cheerleadingHeroSm;
        heroImageMd = cheerleadingHeroMd;
        heroImageLg = cheerleadingHeroLg;
        registrationImage = cheerleadingRegistrationImage;
        schedulingImage = cheerleadingSchedulingImage;
        colorType = "purple";
        break;
      case "Football":
        icon = footballIcon;
        heroImageXs = footballHeroXs;
        heroImageSm = footballHeroSm;
        heroImageMd = footballHeroMd;
        heroImageLg = footballHeroLg;
        registrationImage = footballRegistrationImage;
        schedulingImage = footballSchedulingImage;
        colorType = "green";
        break;
      case "Hockey":
        icon = hockeyIcon;
        heroImageXs = hockeyHeroXs;
        heroImageSm = hockeyHeroSm;
        heroImageMd = hockeyHeroMd;
        heroImageLg = hockeyHeroLg;
        registrationImage = hockeyRegistrationImage;
        schedulingImage = hockeySchedulingImage;
        colorType = "blue";
        break;
      case "Lacrosse":
        icon = lacrosseIcon;
        heroImageXs = lacrosseHeroXs;
        heroImageSm = lacrosseHeroSm;
        heroImageMd = lacrosseHeroMd;
        heroImageLg = lacrosseHeroLg;
        registrationImage = lacrosseRegistrationImage;
        schedulingImage = lacrosseSchedulingImage;
        colorType = "blue";
        break;
      case "Other":
        colorType = "blue";
        heroImageXs = otherSportsHeroXs;
        heroImageSm = otherSportsHeroSm;
        heroImageMd = otherSportsHeroMd;
        heroImageLg = otherSportsHeroLg;
        registrationImage = otherSportsRegistrationImage;
        schedulingImage = otherSportsSchedulingImage;
        colorType = "blue";
        break;
      case "Soccer":
        icon = soccerIcon;
        heroImageXs = soccerHeroXs;
        heroImageSm = soccerHeroSm;
        heroImageMd = soccerHeroMd;
        heroImageLg = soccerHeroLg;
        registrationImage = soccerRegistrationImage;
        schedulingImage = soccerSchedulingImage;
        colorType = "mint";
        break;
      case "Softball":
        icon = softballIcon;
        heroImageXs = softballHeroXs;
        heroImageSm = softballHeroSm;
        heroImageMd = softballHeroMd;
        heroImageLg = softballHeroLg;
        registrationImage = softballRegistrationImage;
        schedulingImage = softballSchedulingImage;
        colorType = "yellow";
        break;
      case "Track And Field":
        icon = trackAndFieldIcon;
        heroImageXs = trackAndFieldHeroXs;
        heroImageSm = trackAndFieldHeroSm;
        heroImageMd = trackAndFieldHeroMd;
        heroImageLg = trackAndFieldHeroLg;
        registrationImage = trackAndFieldRegistrationImage;
        schedulingImage = trackAndFieldSchedulingImage;
        colorType = "green";
        break;
      case "Volleyball":
        icon = volleyballIcon;
        heroImageXs = volleyballHeroXs;
        heroImageSm = volleyballHeroSm;
        heroImageMd = volleyballHeroMd;
        heroImageLg = volleyballHeroLg;
        registrationImage = volleyballRegistrationImage;
        schedulingImage = volleyballSchedulingImage;
        colorType = "purple";
        break;
      case "Wrestling":
        icon = wrestlingIcon;
        heroImageXs = wrestlingHeroXs;
        heroImageSm = wrestlingHeroSm;
        heroImageMd = wrestlingHeroMd;
        heroImageLg = wrestlingHeroLg;
        registrationImage = wrestlingRegistrationImage;
        schedulingImage = wrestlingSchedulingImage;
        colorType = "green";
        break;
    }
    return {
      colorType,
      icon,
      heroImageXs,
      heroImageSm,
      heroImageMd,
      heroImageLg,
      registrationImage,
      schedulingImage,
    };
  }, [type]);

  const { bgColor, bgMobile, bgTablet, bgDesktop } = useMemo(() => {
    let bgMobile;
    let bgTablet;
    let bgDesktop;
    let bgColor;
    switch (colorType) {
      // case "orange":
      //   bgColor = "#FFF6E4";
      //   bgMobile = bgOrangeM;
      //   bgTablet = bgOrangeT;
      //   bgDesktop = bgOrangeD;
      //   break;
      case "blue":
        bgColor = "#DAF2FF";
        bgMobile = bgBlueM;
        bgTablet = bgBlueT;
        bgDesktop = bgBlueD;
        break;
      case "mint":
        bgColor = "#CBFCFF";
        bgMobile = bgMintM;
        bgTablet = bgMintT;
        bgDesktop = bgMintD;
        break;
      case "yellow":
        bgColor = "#FFF6E4";
        bgMobile = bgYellowM;
        bgTablet = bgYellowT;
        bgDesktop = bgYellowD;
        break;
      case "green":
        bgColor = "#DEFFE7";
        bgMobile = bgGreenM;
        bgTablet = bgGreenT;
        bgDesktop = bgGreenD;
        break;
      case "purple":
        bgColor = "#F4E6FF";
        bgMobile = bgPurpleM;
        bgTablet = bgPurpleT;
        bgDesktop = bgPurpleD;
        break;
      // case "purple2":
      //   bgColor = "#F6E4FF";
      //   bgMobile = bgPurple2M;
      //   bgTablet = bgPurple2T;
      //   bgDesktop = bgPurple2D;
      //   break;
    }
    return {
      bgColor,
      bgMobile,
      bgTablet,
      bgDesktop,
    };
  }, [colorType]);

  return {
    icon,
    heroImageXs,
    heroImageSm,
    heroImageMd,
    heroImageLg,
    bgColor,
    bgMobile,
    bgTablet,
    bgDesktop,
    registrationImage,
    schedulingImage,
  };
};

export default useSportsData;
